import { useEffect, useState } from 'react'

import { AuthContext } from './context'

export function AuthContextProvider({ children, keycloak, me }) {
  const [plan, setPlan] = useState({})
  useEffect(() => {
    if (me !== undefined && me?.me?.company?.plan) {
      const basePlan = me?.me?.company?.plan

      const dataFromCompanyPlan = Object.keys(me?.me?.company?.companyPlan).reduce((prev, current) => {
        const baseValues = me?.me?.company?.companyPlan
        if (baseValues?.[current] || baseValues?.[current] === false) {
          return { ...prev, [current]: baseValues[current] }
        }
        return prev
      }, {})
      const finalPlan = { ...basePlan, ...dataFromCompanyPlan }
      setPlan({
        ...finalPlan,
        languageName: me?.me?.company?.companyPlan?.languages,
      })
    }
  }, [me])

  return <AuthContext.Provider value={{ keycloak, me, plan }}>{children}</AuthContext.Provider>
}
